import { Flex } from '@mantine/core';
import { useAuthInfo, withRequiredAuthInfo } from '@propelauth/react';
import usePostHog from '@/hooks/usePosthog.ts';
import useSentry from '@/hooks/useSentry.ts';
import Router from '@/routers/Router.tsx';
import { OrgProjectProvider } from '@/context/OrgProjectContext/OrgProjectProvider';
import RunBrowserNotificationProvider from '@/features/runBrowserNotifications/RunBrowserNotificationProvider.tsx';
import SuiteDraftProvider from '@/context/SuiteDraftContext/SuiteDraftProvider.tsx';

function App() {
  const { user } = useAuthInfo();

  usePostHog(user?.email);
  useSentry(user?.email);

  return (
    <OrgProjectProvider>
      <RunBrowserNotificationProvider>
        <Flex w="100vw" h="100vh">
          <SuiteDraftProvider identity={user?.userId ?? ''}>
            <Router />
          </SuiteDraftProvider>
        </Flex>
      </RunBrowserNotificationProvider>
    </OrgProjectProvider>
  );
}

const AppWithAuth = withRequiredAuthInfo(App);

export default AppWithAuth;
